import React, { useEffect, useContext, useState, useRef } from 'react'
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import {
  Box,
  Button,
} from '@material-ui/core';

import SuperAdminContext from "../../../contexts/SuperAdminContext"

import TopBar from "../../../components/ui/Admin/TopBar"
import GroupForm from '../../../components/ui/Admin/Groups/GroupForm'

import APIS from "../../../utils/APIS"

const NewGroup = () => {
  const navigate = useNavigate()

  const { setOverlayForSave, updateAdminGroupes } = useContext(SuperAdminContext)

  const [group, setGroup] = useState(null)
  const [submitting, setSubmitting] = useState(false)
  const [hasChanged, setHasChanged] = useState(false)


  const onSubmit = (newGroup) => {
    setOverlayForSave(true)
    APIS.addGroupe(newGroup).then((result) => {
      setOverlayForSave(false)
      updateAdminGroupes()
      navigate('/admin/groupe/')
    })

  }

  return (
    <>
      <Helmet>
        <title>Admin Groupes | TheLab</title>
      </Helmet>
      <Box
        sx={{
          backgroundColor: 'background.grey',
          minHeight: '100%',
          py: 0,
          display:"flex",
          flexDirection:"column",
        }}
      >
        <Box
          sx={{
            flex:1,
            padding:"20px",
            backgroundColor:"background.grey",
          }}
        >
          <TopBar
            withBack="/admin/groupe"
            title="Création d'un nouveau groupe"
          >
            <Button
              variant="contained"
              sx={{ minHeight:"35px !important" }}
              onClick={() => {
                document.getElementById('hidden_form_submit').click()
              }}
            >
              Créer le groupe
            </Button>
          </TopBar>

          <GroupForm
            isNew={true}
            group={group}
            hasChanged={hasChanged}
            setHasChanged={setHasChanged}
            onSubmit={onSubmit}
          />


        </Box>
      </Box>
    </>
  )
};

export default NewGroup;
